// extracted by mini-css-extract-plugin
export var button = "_en-0";
export var donut = "_en-1";
export var donutFill = "_en-3";
export var donutTrack = "_en-2";